import Vue from 'vue'
import './index.css'
export class Mask{
    constructor(options){
        this.mask = null;
        /**
         * @param {Object} options
         * @param {Function | any} options.slot -组件插槽
         * @param {Array} options.maskClass -遮罩class
         * @param {Array} options.maskStyle -遮罩style
         * @param {Function} options.handelClick -点击遮罩回调
         * @param {Function} options.handleClose -关闭回调
         * @param {Element} options.getContainer -挂载位置
         * @param {Boolean} options.closeOnClickOverlay -是否可以点击遮罩关闭
         * @param {Boolean} options.isDestroy -是否关闭后自动销毁
         */
        this.options = {
            slot: '',
            maskClass: [],
            maskStyle: [],
            handleClick: () => {},
            handleClose: () => {},
            getContainer: document.body,
            closeOnClickOverlay: true,
            isDestroy: false,
            ...options
        };
    }
    init(){
        const that = this;
        if(!this.mask){
            const MaskConstructor = Vue.extend({
                components: {
                    Comp: typeof that.options.slot === 'function' ? that.options.slot() : that.options.slot
                },
                data(){
                    return {
                        visibility: false
                    }
                },
                render(){
                    return <transition name="fade">
                        {
                            <div style={{display: this.visibility ? 'block' : 'none'}}>
                                <div
                                    class={['mask', ...that.options.maskClass]} 
                                    style={that.options.maskStyle}
                                    onTransitionend={() => {
                                        if(that.options.isDestroy && !this.visibility){
                                            that.destroy();
                                        }
                                    }}
                                    onClick={() => {
                                        if(that.options.closeOnClickOverlay){
                                            that.close();
                                        }
                                        that.options.handleClick();
                                    }}    
                                    >
                                        <Comp />
                                </div> 
                            </div>
                        }
                    </transition>
                },
    
            });
            this.mask = new MaskConstructor();
            this.mask.$mount();
            that.options.getContainer.appendChild(this.mask.$el);
        }
    }

    show(callback = () => {}){
        callback();
        this.mask.visibility = true;
    }

    close(){
        this.options.handleClose();
        this.mask.visibility = false;
    }

    destroy(){
        this.mask?.$destroy();
        this.mask?.$el?.remove();
        this.mask = null;
    }
}